<template>
    <svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M5.8519 0.733978H16.1475V2.7931H21.2953V19.266H0.704102V4.85221H2.76322V17.2069H19.2362V4.85221H14.0884V2.7931H7.91101V4.85221H0.704102V2.7931H5.8519V0.733978ZM13.0588 13.0887H8.94057V15.1478H13.0588V13.0887ZM8.94057 11.0296V13.0887H6.88145V11.0296H8.94057ZM8.94057 8.97045V6.91133H6.88145V8.97045H8.94057ZM15.1179 11.0296V13.0887H13.0588V11.0296H15.1179ZM15.1179 8.97045V6.91133H13.0588V8.97045H15.1179Z"/>
    </svg>
</template>
